export default theme => ({
  wrapperAll: {
    backgroundColor: theme.backgroundColor
  },
  wrapperWithoutFooter: {
    minHeight: theme.minHeight
  },
  regionContainer: {
    backgroundColor: 'white'
  },
  imageProduct: {
    width: 150
  },
  hrSeparator: {
    borderColor: theme.Plan.hrColor
  },
  hrTitle: {
    borderColor: theme.Plan.hrColor,
    marginLeft: '-15px',
    marginRight: '-15px'
  },
  texteProduit: {
    display: 'inline-block',
    paddingLeft: 15
  },
  productContainer: {
    margin: '15px 0',
    display: 'flex',
    alignItems: 'center'
  },
  link: {
    color: theme.link,
    '&:hover': {
      textDecoration: 'none'
    }
  },
  linkProducer: {
    color: theme.linkProducer,
    '&:hover': {
      color: theme.linkHoverProducer,
      textDecoration: 'none'
    }
  }
})
